var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesFechamentoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E4EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1289 10.8374C10.1289 10.4911 10.2701 10.159 10.5215 9.91407C10.7729 9.66919 11.1139 9.53162 11.4694 9.53162H15.9377C16.2932 9.53162 16.6342 9.66919 16.8856 9.91407C17.137 10.159 17.2782 10.4911 17.2782 10.8374V17.8138C17.2782 18.3448 16.6616 18.6538 16.2183 18.3452L13.7035 16.5955L11.1888 18.3452C10.7451 18.6543 10.1289 18.3452 10.1289 17.8142V10.8374Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesFechamentoB);
export default __webpack_public_path__ + "static/media/mesFechamentoB.d9b408a41f16be5508d13d85be73f1b1.svg";
export { ForwardRef as ReactComponent };